import { useField, useFormikContext } from "formik";

import * as formLineStyles from "../FormikFormLine/FormikFormLineStyles";

import Checkbox from "../../common/Checkbox";
import { CheckboxTextStyles } from "./FormikCheckboxStyles";

const FormikCheckbox = ({
  name,
  label,
  disabled,
}: {
  name: string;
  label?: string;
  disabled?: boolean;
}) => {
  const [field] = useField(name);
  const checked = field.value as boolean;
  const { setFieldValue } = useFormikContext();

  return (
    <formLineStyles.Container>
      <CheckboxTextStyles>
        <Checkbox
          checked={checked}
          onChange={() => void setFieldValue(name, !checked)}
          label={label}
          disabled={disabled}
        />
      </CheckboxTextStyles>
    </formLineStyles.Container>
  );
};

export default FormikCheckbox;
